/**
 *  view use: <span>{{ 'aaaa' | test(1234) }}</span>
 *  js use:
 *  import f from '@/plugins/filters/moneyHandler'
 *  f.moneyHandler(12333333)
 *
 */
export default {
	moneyHandler: function (value) {
		const str = value + '';
		const parts = str.split('.');
		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		return parts.join('.');
	}
}
